
import { canv } from '@/canv/global.js'
import { cardWidgetStatusBarCheckBox } from '@/elements/card/statusBar/checkbox.js';
import { cardWidgetStatusBarStatus } from '@/elements/card/statusBar/status.js';
import { drawRoundedRect, isOverRect } from '@/canv/utils.js'


export class cardWidgetStatusBar {

    constructor(startX, startY) {
        this.startX = startX;
        this.startY = startY;
        this.height = 33;

        this.checkbox = new cardWidgetStatusBarCheckBox(0, 0, this.height, this.height);
        this.status = new cardWidgetStatusBarStatus(0, 0, this.height);
    }


    updateCoords(startX, startY) {
        this.startX = startX;
        this.startY = startY;
        this.updateDims();
    }

    updateDims() {
        this.checkbox.updateCoords(this.startX, this.startY);
        
        let checkboxAndStatusGap = 15;
        this.status.updateCoords(this.checkbox.startX + this.checkbox.width + checkboxAndStatusGap, this.startY);

        this.width = this.checkbox.width + checkboxAndStatusGap + this.status.width + this.height; // this.height - это попытка учесть ширину drawPoints. Просто дополнительный гэп
    }



    // helpers

    isStatusClick() {

        if (isOverRect(this.status.startX, this.status.startY, this.status.width, this.status.height)) {
            return true;
        }

        return false;
    }

    isCheckboxClick() {
        if (isOverRect(this.checkbox.startX, this.checkbox.startY, this.checkbox.width, this.checkbox.height)) {
            return true;
        }

        return false;
    }

    setProgressData(progressData, smooth = true) {
        this.checkbox.setIsChecked(progressData["name"] == "done");
        this.status.setProgressData(progressData, smooth);
    }



    // draw

    draw() {
        this.checkbox.draw();
        this.status.draw();
    }




    startX = 0;
    startY = 0;
    width = 0;


    // constants
    height = 0;
}











